import { render, staticRenderFns } from "./CabinErrors.vue?vue&type=template&id=9f395a48&"
import script from "./CabinErrors.vue?vue&type=script&setup=true&lang=js&"
export * from "./CabinErrors.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports